<template lang="pug">
    .settings-page.settings-payouts
        settings-page-head
        .settings-page__body

            .payout-panel
                .payout-plate.daily
                    .payout-plate__title DAILY
                    .payout-plate__total {{ totals.day || 0 | currency }}
                .payout-plate.weekly
                    .payout-plate__title WEEKLY
                    .payout-plate__total {{ totals.week || 0 | currency }}
                .payout-plate.monthly
                    .payout-plate__title MONTHLY
                    .payout-plate__total {{ totals.month || 0 | currency }}
                .payout-plate.yearly
                    .payout-plate__title YEARLY
                    .payout-plate__total {{ totals.year || 0 | currency }}

            template(v-if="payouts.length")
                .scrollable-table
                    table.table.table-borderless.table-striped.settings-table.settings-table
                        thead
                            th Customer
                            th Price
                            th Purchase Date
                            th Payout
                            th Platform Fee
                            th Status
                        tbody
                            tr(v-for="payout in pagePayouts")
                                td {{ payout.order_user.data.name }}
                                td {{ payout.total | currency }}
                                td.text-muted
                                    time(:datetime="payout.created_at") {{ moment(payout.created_at).format('MMM D, h:mm A') }}
                                td {{ payout.amount | currency }}
                                td {{ payout.item.data.fees | currency }}
                                td
                                    .settings-table__status(:class="payout.state") {{ payout.state }}
                settings-table-paging(v-if="pages > 1" :page="page" :pages="pages" @click="page = $event.page")

</template>

<script>
import moment from 'moment'

const PAGE_SIZE = 7

export default {
    name: 'settings-payouts',

    data() { return {
        totals: {},
        payouts: [],
        page: 1,
        pages: 0,
    }},

    computed: {
        pagePayouts() {
            return this.payouts
                .slice(PAGE_SIZE * (this.page - 1), PAGE_SIZE * this.page)
        },
    }, 

    async created() {
        const { data: totals } = await axios.get('/api/customer/user/payout/total')
        this.totals = totals

        const { data: { data: payouts } } = await axios.get('/api/customer/user/payout?include=item')
        this.payouts = payouts.filter(payout => payout.state != 'created')
        this.pages = Math.floor((payouts.length - 1) / PAGE_SIZE + 1)
    },

    methods: {
        moment,
    }
}
</script>
